// constants.js

export const DEFAULT_LIMIT = 50;

export const PROSPECTION_TABS = [
  {
    key: "prospects",
    label: "Prospects",
    description: "Base contacts, filtres, import, qualification",
  },
  {
    key: "campaigns",
    label: "Campagnes",
    description: "Préparation, tests, lancement et suivi",
  },
  {
    key: "templates",
    label: "Modèles d’emails",
    description: "Emails enrichis, boutons, images, signatures",
  },
  {
    key: "senders",
    label: "Expéditeurs",
    description: "Adresses d’envoi, limites, identité",
  },
];

export const PRODUCT_OPTIONS = [
  {
    value: "monappliclub",
    label: "MonAppliClub",
  },
  {
    value: "monapplimairie",
    label: "MonAppliMairie",
  },
  {
    value: "monapplitournoi",
    label: "MonAppliTournoi",
  },
  {
    value: "presence_pro",
    label: "Présence Pro",
  },
  {
    value: "judo_coach_pro",
    label: "Judo Coach Pro",
  },
  {
    value: "secusport_ia",
    label: "SécuSport IA",
  },
  {
    value: "autre",
    label: "Autre",
  },
];

export const CAMPAIGN_STATUS = [
  {
    value: "draft",
    label: "Brouillon",
    className:
      "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
  },
  {
    value: "prepared",
    label: "Préparée",
    className:
      "bg-blue-100 text-blue-700 dark:bg-blue-900/40 dark:text-blue-200",
  },
  {
    value: "scheduled",
    label: "Planifiée",
    className:
      "bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-200",
  },
  {
    value: "running",
    label: "En cours",
    className:
      "bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-200",
  },
  {
    value: "paused",
    label: "En pause",
    className:
      "bg-amber-100 text-amber-700 dark:bg-amber-900/40 dark:text-amber-200",
  },
  {
    value: "completed",
    label: "Terminée",
    className:
      "bg-green-100 text-green-700 dark:bg-green-900/40 dark:text-green-200",
  },
  {
    value: "cancelled",
    label: "Annulée",
    className:
      "bg-rose-100 text-rose-700 dark:bg-rose-900/40 dark:text-rose-200",
  },
];

export const RECIPIENT_STATUS = [
  "queued",
  "sending",
  "sent",
  "opened",
  "clicked",
  "bounced",
  "unsubscribed",
  "failed",
  "skipped",
];

// Statut du site
export const SITE_STATUS = [
  "Inexistant",
  "Daté",
  "Mairie",
  "FFJDA",
  "Google",
  "AssoConnect",
  "Pepsup",
  "Sports Région",
  "Clubeo",
  "Jimdo",
  "Wix",
  "WordPress",
  "E-monsite",
  "Website",
];

// Statuts du prospect
export const STATUTS_CANON = [
  "A contacter",
  "Intérêt",
  "Prospect",
  "Prospect +",
  "Client",
  "Perdu",
  "Désinscrit",
  "Mail invalide",
];

export function getCampaignStatusMeta(status) {
  return (
    CAMPAIGN_STATUS.find((s) => s.value === status) || {
      value: status,
      label: status || "—",
      className:
        "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-200",
    }
  );
}

export function getProductLabel(value) {
  return PRODUCT_OPTIONS.find((p) => p.value === value)?.label || value || "—";
}

// Couleurs de lignes par statut prospect
export function statutRowClasses(statut) {
  switch (statut) {
    case "A contacter":
      return "bg-blue-300/30";
    case "Prospect":
      return "bg-amber-300/30";
    case "Prospect +":
      return "bg-orange-300/40";
    case "Intérêt":
      return "bg-yellow-300/40";
    case "Client":
      return "bg-emerald-300/40";
    case "Perdu":
      return "bg-rose-300/40";
    case "Désinscrit":
      return "bg-slate-300/50";
    case "Mail invalide":
      return "bg-purple-300/40";
    default:
      return "";
  }
}